'use client';

import { createTheme, ThemeOptions } from '@mui/material/styles';
import responsiveBaseTheme from '@/styles/brands/base';
import deepmerge from '@mui/utils/deepmerge';

const dt = createTheme(
	deepmerge(responsiveBaseTheme, {
		palette: {
			primary: {
				main: 'rgba(1, 92, 171, 1)', // #015CAB
			},
			secondary: {
				main: 'rgba(1, 51, 94, 1)', // #E6EFF7
			},
			accent: {
				main: 'rgba(230, 239, 247, 1)', // #01335E
			},
			lightBackground: {
				main: 'rgba(230, 239, 247, 1)', // #E6EFF7
			},
		},
	} as ThemeOptions),
);

export default dt;
